import React from "react";
import { useDispatch, useSelector } from "react-redux";
import NavbarIconsCatalogRoles from "../generic-nav-bar/NavbarIconsCatalogRoles";
import { catalogRoleStartRegister } from "../../app/actions/catalogRoleActions";
import { useTranslation } from "react-i18next";
import { debugLogPages } from "../../app/helpers/debugHelper";
import useFormValidationsGeneric from "../../app/hooks/useFormValidationsGeneric";
import { schemaValidateCatalogRolesList } from "../../app/data/schemaValidateCatalogRolesList";
import ViewLabel from "../generic-component/ViewLabel";
import NewInputGeneric from "../generic-component/NewInputGeneric";
import NewRelationGeneric from "../generic-component/NewRelationGeneric";
import NewTextGeneric from "../generic-component/NewTextGeneric";
import EditYearGeneric from "../generic-component/EditYearGeneric";
import NewDateGeneric from "../generic-component/NewDateGeneric";
import NewCatalogRelationGeneric from "../generic-component/NewCatalogRelationGeneric";
import NewCatalogLocationGeneric from "../generic-component/NewCatalogLocationGeneric";
import { useNavigate } from "react-router-dom";

const ID_FORM = "admin-catalog-role";
const OPERATION = "register";

const NewCatalogRoles = () => {
  debugLogPages(':: NewCatalogRoles'); 

    const navigate = useNavigate();

  const dispatch = useDispatch();
  const { catalogRole } = useSelector((state) => state.catalogRole);
  const { t } = useTranslation();

  const { values, errors, handleChange, handleSubmit, handleChangeCatalogCiiu,
    handleChangeCatalogSection, handleChangeCatalogPhase, handleChangeLocation } = useFormValidationsGeneric(
      () => catalogRoleCallback(),
      catalogRole,
      schemaValidateCatalogRolesList
    );

  const catalogRoleCallback = () => {
    debugLogPages(':: NewCatalogRoles, catalogRoleCallback, values', {values}); 

    let valuesSubmit = { ...values };

    valuesSubmit.deleted = false;

    debugLogPages(':: NewCatalogRoles, catalogRoleCallback, valuesSubmit', {valuesSubmit}); 
    dispatch(catalogRoleStartRegister(valuesSubmit, navigate));

  };

  debugLogPages(':: NewCatalogRoles', {errors}); 
  debugLogPages(':: NewCatalogRoles', {values}); 

  return (
    <div>
      <NavbarIconsCatalogRoles page={"newCatalogRoles"} />
      <div className="d-flex justify-content-center page-title">{t(`${ID_FORM}.page.${OPERATION}`)}</div>

      <hr className="line-hr" />

      <div className="section is-fullheight">
        <div className="container">
          <form onSubmit={handleSubmit} noValidate>

            {/* Formulario dinamico*/}

            <div className="row boxContent">
              {
                schemaValidateCatalogRolesList && schemaValidateCatalogRolesList.length > 0 && (
                  schemaValidateCatalogRolesList.map((techSecondary, index) => {
                    
                    let varField = techSecondary.field;
                    let varRelation = techSecondary.key_relation;

                    if (techSecondary.component_new === "ViewGroupLabel") {
                      return (
                        <ViewLabel
                          key={techSecondary.id}
                          values={values}
                          errors={errors}
                          values2={varRelation}
                          field={varField}
                          max_length={techSecondary.max_length}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_view}
                        />
                      )
                    } if (techSecondary.component_new === "NewInputGeneric") {
                      return (
                        <NewInputGeneric
                          key={techSecondary.id}
                          handleChange={handleChange}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          max_length={techSecondary.max_length}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                        />
                      );
                    } else if (techSecondary.component_new === "NewRelationGeneric") {
                      return (
                        <NewRelationGeneric
                          key={techSecondary.id}
                          handleChange={handleChange}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                        
                        />
                      );
                    } else if (techSecondary.component_new === "NewTextGeneric") {
                      return (
                        <NewTextGeneric
                          key={techSecondary.id}
                          handleChange={handleChange}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          max_length={techSecondary.max_length}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                        />
                      );
                    } else if (techSecondary.component_new === "NewYearGeneric") {

                      return (
                        <EditYearGeneric
                          key={techSecondary.id}
                          handleChange={handleChange}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                        />
                      );
                    } else if (techSecondary.component_new === "NewDateGeneric") {
                      return (
                        <NewDateGeneric
                          key={techSecondary.id}
                          handleChange={handleChange}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                        />
                      );
                    } else if (techSecondary.component_new === "NewCatalogRelationGeneric") {
                      if (techSecondary.comparable_relation_condition === "CatalogCiius") {
                        return (
                          <NewCatalogRelationGeneric
                            key={techSecondary.id}
                            handleChange={handleChangeCatalogCiiu}
                            values={values}
                            errors={errors}
                            placeholderVal={techSecondary.is_placeholder}
                            field={varField}
                            max_length={techSecondary.max_length}
                            moduleText={techSecondary.module_text}
                            occupation={techSecondary.occupation_new}

                          />
                        );
                      } else if (techSecondary.comparable_relation_condition === "CatalogSections") {
                        return (
                          <NewCatalogRelationGeneric
                            key={techSecondary.id}
                            handleChange={handleChangeCatalogSection}
                            values={values}
                            errors={errors}
                            placeholderVal={techSecondary.is_placeholder}
                            field={varField}
                            max_length={techSecondary.max_length}
                            moduleText={techSecondary.module_text}
                            occupation={techSecondary.occupation_new}

                          />
                        );
                      } else if (techSecondary.comparable_relation_condition === "CatalogPhases") {
                        return (
                          <NewCatalogRelationGeneric
                            key={techSecondary.id}
                            handleChange={handleChangeCatalogPhase}
                            values={values}
                            errors={errors}
                            placeholderVal={techSecondary.is_placeholder}
                            field={varField}
                            max_length={techSecondary.max_length}
                            moduleText={techSecondary.module_text}
                            occupation={techSecondary.occupation_new}

                          />
                        );
                      }
                    } else if (techSecondary.component_new === "NewCatalogLocationGeneric") {
                      return (
                        <NewCatalogLocationGeneric
                          key={techSecondary.id}
                          handleChange={handleChangeLocation}
                          values={values}
                          errors={errors}
                          placeholderVal={techSecondary.is_placeholder}
                          field={varField}
                          moduleText={techSecondary.module_text}
                          occupation={techSecondary.occupation_new}
                        
                        />
                      );
                    } else {
                      return (
                        <div>
                        </div>
                      )
                    }
                  })
                )
              }
            </div>

            {/* Fin Formulario dinamico */}

            <div className="btnGuardar">
              <input type="submit" value={t("buttons.submit")} className="btn btn-primary" />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default NewCatalogRoles;
